import { Box } from "@primer/react";
import { ArrowRightIcon } from "@primer/octicons-react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Text from "../components-ui/text";
import BrandLogo from "../components-ui/brand-logo";
import Button from "../components-ui/button";
import { AuthProvider, AuthProviderProps, useAuth } from "oidc-react";
import { useEffect, useMemo } from "react";
import { appConst } from "../AppConst";
import { useAppDispatch } from "../hooks/useAppDispatch";
import { rootActions } from "../state/actions/rootActions";
import LoaderPage from "../components-ui/loader-page";

const LoginOidcPage = () => {
    debugger
    const auth = useAuth();

    const { userData, userManager } = auth;
  
    const dispatch = useAppDispatch();
    console.log({
        userData,
        userManager
    });

    const id_token = userData ? userData.id_token : "";
    const email = (userData && userData.profile) ? userData.profile.email : "";
    const access_token = userData ? userData.access_token : "";
    const refresh_token = userData ? userData.refresh_token ?? "" : "";



    useEffect(() => {


        if (access_token && id_token) {
            console.log({
                access_token,
                id_token,
                email,
                refresh_token
            });

            dispatch(rootActions.auth.LOGIN_START({
                access_token,
                id_token,
                refresh_token
            }))

        }

    }, [access_token, id_token])

    return (
        <LoaderPage />
    );
}

const LogoutPage = () => {
    const auth = useAuth();
    const { userData } = auth;
    const navigate = useNavigate();

    useEffect(() => {
        doSignOutAsync();
    }, []);
    const doSignOutAsync = async () => {
        // await auth.signOut();
        // navigate("../../login")
        // debugger;
        await auth.signOutRedirect({
            id_token_hint: userData?.id_token
        });
        navigate("../../login")
    }

    return (
        <LoaderPage />
    );

}

const LoginForm = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            backgroundColor: "rgba(255,255,255,0.9)",
            backdropFilter: "blur(2rem)",
            width: 400,
            padding: 24,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",

        }}>
            <div style={{
                marginBottom: 3,
                display: "flex",
                justifyContent: "center"

            }}>
                <div style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column"
                }}>
                    <Text text="Đăng nhập" style={{fontSize: 24,fontWeight: "bolder"}} />
                    <Text text="Xác thực bằng cổng đăng nhập tập trung" sx={{
                        color: "fg.muted",
                        mb: 3
                    }}
                    />
                </div>

                <BrandLogo height={64} />
            </div>
            <div>
                <Button text="Tiếp tục" variant="primary" onClick={() => {
                    navigate(`../../signin-oidc`)
                }}
                    trailingVisual={ArrowRightIcon}
                    block
                    size="medium"
                    style={{
                        marginBottom: 2,
                        backgroundColor: "var(--primary)",
                        color: "var(--button-primary-fgColor-rest)",
                    }}
                />

            </div>
        </div>
    );
}
const OidcContent = () => {
    const oidcConfig: AuthProviderProps = useMemo(() => {
        debugger;
        return {
            onSignIn: (e: any) => {
                // debugger
                console.log({
                    onSignIn: e
                });
            },
        
            authority: appConst?.OIDC_AUTHORITY,
            clientId: appConst?.OIDC_CLIENT_ID,
            redirectUri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/signin-oidc`, //appConst?.OIDC_REDIRECT_URI,
            clientSecret: appConst?.OIDC_CLIENT_SECRET,
            responseType: "code",
            automaticSilentRenew: true,
            scope: "openid profile email offline_access",
            postLogoutRedirectUri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`,
        };
    }, [appConst])
    console.log({
        oidcConfig
    });
    
    return (
        <AuthProvider {...oidcConfig} >
            <Routes>

                <Route path={`/signin-oidc`} Component={LoginOidcPage} />
                <Route path={`/signout-oidc`} Component={LogoutPage} />
                <Route path="*" element={<Navigate to={"/login"} replace />} />
                </Routes>
            </AuthProvider>
        );
}

const UnAuthorizedContent = () => {


    return (
        <div
            style={{
                backgroundImage: "url(../../../images/background.png)",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                minHeight: window.innerHeight,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <Routes>
                <Route path={`/login`} Component={LoginForm} />
                <Route path="*" Component={OidcContent} />
            </Routes>
        </div>
    );
};

export default UnAuthorizedContent;